import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../../../constants'

export const Percentage = styled.span`
    font-size: 12px;
`

export const FlagWrapper = styled.div`
    margin: 0 auto;
    width: 20px;
`

export const Icon = styled(FontAwesomeIcon)`
    color: ${(props) => props.color};
`

export const ActionGroup = styled.div`
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.5s;

    *:hover > * > & {
        opacity: 1;
        transform: translateX(0);
    }
`

export const StyledLink = styled(Link)`
    color: ${colors.white};
    cursor: pointer;
    flex: 1;
    float: right;
    font-size: 14px;
    text-decoration: none;
    width: 100%;

    &:last-child {
        margin-right: 0;
    }
`

export const ClearFilters = styled.button<{ show?: boolean }>`
    border-radius: 2px 0 0 2px;
    color: #a32632;
    font-size: 16px;
    width: 20px;
    position: absolute;
    top: 11px;
    right: 12px;
    border: 0;
    background: transparent;
    height: 15px;
    width: 15px;
    cursor: pointer;
    display: none;

    ${({ show = false }) =>
        show && `display: block;`}
}
`

export const ClearFiltersIcon = styled.div`
    background: ${colors.reddark};
    border-radius: 2px 0 0 2px;
    color: white;
    font-size: 14px;
    height: 100%;
    width: 20px;
    position: absolute;
    left: 0;
    top: 0;
`

export const TimesIcon = styled(FontAwesomeIcon)`
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`

interface InlineProps {
    show?: boolean
    animation?: boolean
}

export const Inline = styled.div<InlineProps>`
    width: auto;
    display: inline-block;
    vertical-align: middle;
    position: relative;

    @keyframes expan {
        0% {
            width: 0;
            transform: scaleX(0);
        }
        1% {
            width: auto;
        }
        10% {
            width: auto;
            transform: scaleX(1);
        }
    }

    @keyframes collapse {
        0% {
            width: auto;
            transform: scaleX(1);
        }
        99% {
            width: auto;
        }
        100% {
            width: 0;
            transform: scaleX(0);
        }
    }

    ${({ show = false, animation = false }) => {
        if (!animation) {
            return ''
        }

        if (show) {
            return `
        animation-name: collapse;
        animation-duration: 0.3s;
      `
        }

        return `
      animation-name: collapse;
      animation-duration: 0.3s;
    `
    }}
`

export const FilteredItems = styled.div`
    color: black;
    font-size: 15px;
    position: absolute;
    right: 22px;
`
